<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.activeStorageBlob')"
    namespace="active_storage/"
    resource="blobs"
    ref="sourcePage"
  >
    <template v-slot:action>
      <MultipleUpload
        directory
        :limit="100"
        accept="*"
        :size="200"
        :title="$t('batchUpload')"
        @success="handleBatchUploadSucceed"
      />
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { CONTENT_TYPES } from '@/constants';
import MultipleUpload from 'beans-admin-plugin/components/upload';

@Component({
  components: {
    MultipleUpload
  }
})
export default class Blobs extends Vue {
  @Prop(String) type;

  handleBatchUploadSucceed() {
    this.$refs.sourcePage.fetchData();
  }

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'filename_cont',
        label: this.$t('activeStorageBlob.filename'),
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'content_type_cont',
        label: this.$t('activeStorageBlob.contentType'),
        renderCell: {
          component: 'select',
          props: {
            options: _.map(CONTENT_TYPES, (value) => ({ label: this.$t(`activeStorageBlob.contentTypes.${value}`), value: value })),
            clearable: true
          }
        }
      },
      // {
      //   prop: 'tags_name_in',
      //   label: this.$t('model.actsAsTaggableOnTag'),
      //   minWidth: 150,
      //   renderCell: {
      //     component: 'select',
      //     props: {
      //       clearable: true,
      //       multiple: true,
      //       'x-remote': {
      //         strategy: 'search',
      //         remoteMethod: async (name_cont) => {
      //           const { data } = await this.$request.get('/acts_as_taggable_on/tags', { params: { name_cont } })
      //           return _.map(data, ({ name }) => ({ value: name, label: name }))
      //         }
      //       }
      //     }
      //   }
      // },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'filename',
        label: this.$t('activeStorageBlob.filename'),
      },
      {
        prop: 'content_type',
        label: this.$t('activeStorageBlob.contentType'),
      },
      {
        prop: 'url',
        label: this.$t('activeStorageBlob.url'),
        minWidth: 150,
        renderCell: (h, { props: { scope: { row } } }) => {
          const imageProps = type === 'show' ? { style: 'width: 200px;height:200px' } : {};
          return <bean-resource-render
            value={row}
            imageProps={imageProps}
          />
        }
      },
      // {
      //   prop: 'tag_list',
      //   label: this.$t('model.actsAsTaggableOnTag'),
      //   minWidth: 150,
      //   renderCell: (h, { props: { value } }) => {
      //     return (_.map(value, (tag) => (<el-tag style={{ 'margin-right': '3px' }}>{ tag.length > 10 ? (tag.slice(0, 10) + '...') : tag }</el-tag>)))
      //   }
      // },
      {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'filename',
        label: this.$t('activeStorageBlob.filename'),
        renderCell: {
          component: 'input'
        }
      },
      // {
      //   prop: 'tag_list',
      //   label: this.$t('model.actsAsTaggableOnTag'),
      //   renderCell: {
      //     component: 'select',
      //     style: 'width: 100%',
      //     props: {
      //       clearable: true,
      //       multiple: true,
      //       'allow-create': true,
      //       'default-first-option': true,
      //       'x-remote': {
      //         strategy: 'search',
      //         remoteMethod: async (name_cont) => {
      //           const { data } = await this.$request.get('/acts_as_taggable_on/tags', { params: { name_cont } })
      //           return _.map(data, ({ name }) => ({ value: name, label: name }))
      //         }
      //       }
      //     }
      //   }
      // },
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'blobs.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'blobs.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/blobs',
    name: 'blobs.index',
    component: Blobs,
    props: {
      type: 'index',
    }
  },
  {
    path: '/blobs/new',
    name: 'blobs.new',
    component: Blobs,
    props: {
      type: 'new',
    }
  },
  {
    path: '/blobs/:id',
    name: 'blobs.show',
    component: Blobs,
    props: {
      type: 'show',
    }
  },
  {
    path: '/blobs/:id/edit',
    name: 'blobs.edit',
    component: Blobs,
    props: {
      type: 'edit'
    }
  }
]
</script>
